import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Guide.css';

const Guide: React.FC = () => {
  const { user } = useAuth();
  const [activeSection, setActiveSection] = useState('start');

  const sections = [
    { id: 'start', title: 'Дашборд' },
    { id: 'cameras', title: 'Участки и камеры' },
    { id: 'categories', title: 'Категории и журнал' },
    { id: 'reports', title: 'Статистика и отчёты' },
    { id: 'presence', title: 'Присутствие и рабочие места' },
    { id: 'accounts', title: 'Субаккаунты' },
    { id: 'telegram', title: 'Уведомления' },
    { id: 'safety', title: 'Безопасная работа' },
    { id: 'help', title: 'Если что-то не работает' },
  ];

  return <div className="guide-page ui-page">
    <header className="ui-page-head guide-head">
      <div className="ui-page-head__text">
        <h1 className="ui-page-head__title">Руководство пользователя</h1>
        <p className="ui-page-head__subtitle">Коротко и простыми словами о том, как пользоваться Flypix</p>
      </div>
      <Link to="/dashboard" className="ui-btn ui-btn--outline">Перейти на дашборд</Link>
    </header>

    <div className="guide-layout">
      <nav className="guide-index" aria-label="Содержание руководства">
        <p className="guide-index__title">В этом руководстве</p>
        {sections.map((section) => <button
          key={section.id}
          type="button"
          className={activeSection === section.id ? 'is-active' : ''}
          aria-current={activeSection === section.id ? 'page' : undefined}
          onClick={() => setActiveSection(section.id)}
        >{section.title}</button>)}
      </nav>

      <main className="guide-content">
        {activeSection === 'start' && <section className="guide-section" id="start">
          <span className="guide-section__number">01</span>
          <div><h2>Дашборд</h2>
            <div className="guide-qa"><h3>Что показывает дашборд?</h3><p>Основные показатели, последние события и быстрые переходы к разделам. Нажмите «Все события», чтобы открыть полный журнал.</p></div>
            <div className="guide-qa"><h3>Почему я вижу не все данные?</h3><p>Субаккаунт показывает только те участки и категории, к которым владелец выдал доступ.</p></div>
          </div>
        </section>}

        {activeSection === 'cameras' && <section className="guide-section" id="cameras">
          <span className="guide-section__number">02</span>
          <div><h2>Участки и камеры</h2>
            <div className="guide-qa"><h3>Что такое участок?</h3><p>Это группа камер одного объекта или территории. Выберите участок в боковом меню, чтобы посмотреть доступные камеры и события.</p></div>
            <div className="guide-qa"><h3>Как переключить камеру?</h3><p>Откройте участок и выберите нужную камеру в списке.</p></div>
            <div className="guide-qa"><h3>Кто может добавлять камеры?</h3><p>{user?.is_subaccount ? 'Добавление участков и камер доступно владельцу аккаунта. Если нужной камеры нет, попросите его проверить ваши права.' : 'Добавлять и оплачивать камеры может основной аккаунт.'}</p></div>
          </div>
        </section>}

        {activeSection === 'categories' && <section className="guide-section" id="categories">
          <span className="guide-section__number">03</span>
          <div><h2>Категории и журнал событий</h2>
            <div className="guide-qa"><h3>Почему в категории собраны камеры с разных участков?</h3><p>Категория показывает все доступные камеры, на которых включён соответствующий вид распознавания.</p></div>
            <div className="guide-qa"><h3>Как найти нужное событие?</h3><p>Выберите камеру, вид события и период. В категории «Автономера» можно искать по номеру. Кнопка «Просмотр» открывает снимок, если он доступен.</p></div>
            <div className="guide-qa"><h3>Почему категории нет в меню?</h3><p>Она появляется, когда на доступной вам камере включён соответствующий вид распознавания.</p></div>
          </div>
        </section>}

        {activeSection === 'reports' && <section className="guide-section" id="reports">
          <span className="guide-section__number">04</span>
          <div><h2>Статистика и отчёты</h2>
            <div className="guide-qa"><h3>Где посмотреть статистику?</h3><p>Нажмите «Статистика» на дашборде. Там показаны события за сегодня, за семь дней и их распределение.</p></div>
            <div className="guide-qa"><h3>Почему отчёт пустой?</h3><p>Проверьте период и доступ к нужным участкам или категориям. Если за выбранное время событий не было, отчёт будет пустым.</p></div>
          </div>
        </section>}

        {activeSection === 'presence' && <section className="guide-section" id="presence">
          <span className="guide-section__number">05</span>
          <div><h2>Присутствие и рабочие места</h2>
            <div className="guide-qa"><h3>Что означают события рабочего места?</h3><p>Журнал показывает, когда место опустело и когда человек вернулся. Для каждого места владелец может задать своё название.</p></div>
            <div className="guide-qa"><h3>Где посмотреть длительность отсутствия?</h3><p>Откройте статистику присутствия за нужный день: там указаны число и общая длительность отсутствий, а также текущее отсутствие, если человек ещё не вернулся.</p></div>
          </div>
        </section>}

        {activeSection === 'accounts' && <section className="guide-section" id="accounts">
          <span className="guide-section__number">06</span>
          <div><h2>Субаккаунты</h2>
            <div className="guide-qa"><h3>Как сотруднику выдать отдельный вход?</h3><p>Основной аккаунт создаёт субаккаунт и выбирает, какие участки и категории будут доступны сотруднику.</p></div>
            <div className="guide-qa"><h3>Кто отвечает за камеры и оплату?</h3><p>Настройка и оплата камер остаются у владельца основного аккаунта. Права сотрудника можно изменить или отключить.</p></div>
          </div>
        </section>}

        {activeSection === 'telegram' && <section className="guide-section" id="telegram">
          <span className="guide-section__number">07</span>
          <div><h2>Уведомления</h2>
            <div className="guide-qa"><h3>Как подключить Telegram?</h3><p>Откройте профиль, выберите уведомления в Telegram, перейдите в бот и нажмите «Старт». Состояние подключения обновится автоматически.</p></div>
            <div className="guide-qa"><h3>Как отключить уведомления?</h3><p>Нажмите «Отвязать Telegram» и подтвердите действие. Если подключение не работает, попробуйте позже или обратитесь к владельцу аккаунта.</p></div>
          </div>
        </section>}

        {activeSection === 'safety' && <section className="guide-section guide-section--safety" id="safety">
          <span className="guide-section__number">08</span>
          <div><h2>Безопасная работа</h2>
            <div className="guide-qa"><h3>Как защитить свой аккаунт и данные?</h3>
            <ul>
              <li>Не передавайте свой пароль другим людям. Для сотрудников создавайте отдельные аккаунты.</li>
              <li>Используйте пароль, который не применяется на других сайтах, и не отправляйте его в переписке.</li>
              <li>Выдавайте доступ только к нужным участкам и категориям. Удаляйте или отключайте доступ, если сотрудник больше не работает с системой.</li>
              <li>Выходите из аккаунта на общем или чужом устройстве.</li>
              <li>Не публикуйте записи, снимки и ссылки на камеры в открытом доступе. Передавайте их только тем, кому это разрешено.</li>
              <li>Если вы заметили незнакомые действия в аккаунте, смените пароль и сообщите владельцу аккаунта.</li>
            </ul>
            </div>
          </div>
        </section>}

        {activeSection === 'help' && <section className="guide-section" id="help">
          <span className="guide-section__number">09</span>
          <div><h2>Если что-то не работает</h2>
            <div className="guide-qa">
            <h3>Что проверить в первую очередь?</h3>
            <ul>
              <li><strong>Не вижу камеру:</strong> проверьте выбранную категорию и попросите владельца аккаунта проверить выданные права.</li>
              <li><strong>Нет событий:</strong> выберите более широкий период и проверьте, что для этой камеры включено нужное распознавание.</li>
              <li><strong>Не открывается видео:</strong> обновите страницу и попробуйте выбрать камеру ещё раз. Если проблема остаётся, сообщите владельцу аккаунта.</li>
              <li><strong>Не подключается Telegram:</strong> повторите попытку позже. Не отправляйте кому-либо ссылку для привязки — она предназначена только для вашего аккаунта.</li>
            </ul>
            </div>
          </div>
        </section>}

        {activeSection === 'help' && <aside className="guide-note"><strong>Нужна помощь?</strong><span>Обратитесь к владельцу аккаунта или в службу поддержки и укажите, что именно вы открывали и что увидели. Не отправляйте пароль и личные ссылки на камеры.</span></aside>}
      </main>
    </div>
  </div>;
};

export default Guide;
